import React, { CSSProperties, FC, useState } from 'react';
import Truncate from 'react-truncate';
import { Text } from 'components/text/Text';

type Props = {
  text: string;
  showMoreCTA: string;
  maxLines?: number;
  style?: CSSProperties;
};

export const ExpandableText: FC<Props> = ({ text, maxLines = 3, showMoreCTA, style = {} }) => {
  const [lines, setLines] = useState(maxLines);
  const removeTruncate = () => setLines(-1); // -1 removes truncating

  return (
    <Truncate
      lines={lines}
      ellipsis={
        <>
          <Text>...</Text>
          <br />
          <Text
            fontWeight={600}
            underline
            onClick={removeTruncate}
            style={{ cursor: 'pointer', ...style }}
          >
            {showMoreCTA}
          </Text>
        </>
      }
    >
      {text}
    </Truncate>
  );
};
